import CompanyServicePortalModal from './companyServicePortalModal';

export default CompanyServicePortalModal;
